import objectAssign from 'object-assign';
const config = {};

const actions = {
  UI_COLOR_CHANGE: 'UI_COLOR_CHANGE',
  SCROLLED_PAST_TITLE: 'SCROLLED_PAST_TITLE',
};

const constants = objectAssign(config, actions);

export default constants;



/** WEBPACK FOOTER **
 ** ./assets/js/src/constants/AppConstants.js
 **/